export default "/images/widget.svg?0f25598b7d5a11d02082f7c57bdec36e";